class WFaq extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;

    this.tabs = Array.from(this.querySelectorAll('.w-faq__tab'));
    this.items = Array.from(this.querySelectorAll('.w-faq__item'));
    this.list = this.querySelector('.w-faq__list');
    this.openFirst = this.dataset.openFirst === 'true';

    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.filter(tab), { signal }));

    this.list?.addEventListener('click', (event) => {
      const trigger = event.target.closest('.w-faq__q');
      if (trigger && this.list.contains(trigger)) this.toggle(trigger);
    }, { signal });

    const active = this.tabs.find((tab) => tab.classList.contains('is-active')) || this.tabs[0];
    this.apply(active ? active.dataset.filter : '*', this.openFirst);
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  toggle(trigger, force) {
    const open = force === undefined ? trigger.getAttribute('aria-expanded') !== 'true' : force;
    trigger.setAttribute('aria-expanded', String(open));
    trigger.closest('.w-faq__item')?.classList.toggle('is-open', open);
  }

  filter(tab) {
    this.tabs.forEach((other) => {
      const active = other === tab;
      other.classList.toggle('is-active', active);
      other.setAttribute('aria-selected', String(active));
    });
    this.apply(tab.dataset.filter, this.openFirst);
  }

  apply(filterValue, openFirst) {
    let first = null;
    this.items.forEach((item) => {
      const category = item.dataset.category;
      const match = filterValue === '*' || category === '' || category === filterValue;
      item.hidden = !match;
      const trigger = item.querySelector('.w-faq__q');
      if (trigger) this.toggle(trigger, false);
      if (match && !first) first = trigger;
    });
    if (openFirst && first) this.toggle(first, true);
  }
}

customElements.define('w-faq', WFaq);
